// Shared branding inputs for the combined-workspace PDF, used by both the
// Combined PDF preview popup and the confirm-page "Finish" action so the two
// entry points generate an identically branded PDF.

// The PDF/preview color scheme follows the tenant brand color (--color-primary,
// set on :root from the i18n theme); the backend defaults to blue if absent.
export const readBrandAccent = (): string | undefined => {
  const c = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim();
  return c || undefined;
};

// Distributor logo from the tenant/rule-set i18n (the same variable the legacy
// PDF used). i18next returns the key itself when the variable is unset; resolve
// a relative asset path to an absolute URL so Gotenberg can fetch it.
export const resolveLogoUrl = (raw: string): string | undefined => {
  if (!raw || raw === 'variables.pdf.logo') return undefined;
  if (raw.startsWith('http') || raw.startsWith('data:')) return raw;
  return `${window.location.origin}${raw}`;
};
